import { AxiosError } from 'axios'

const parseJwtPayload = (jwt: string) => {
  try {
    return JSON.parse(atob(jwt.split('.')[1]))
  } catch (e) {
    return null
  }
}

const isUnauthorized = (error: AxiosError) => {
  return error.response?.status === 401
}

export {
  parseJwtPayload,
  isUnauthorized
}
